var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('general-header',{attrs:{"content":{
            header: 'Contact Us',
            subheader: '',
            buttonText: '',
            buttonIcon: '',
            iconPosition: '',
            to: '',
            link: ''
        }}}),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"contact-main"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_vm._v("\n                    Contact us "),_c('a',{attrs:{"href":"mailto:innermonkdesign@gmail.com"}},[_vm._v("here")]),_vm._v(" through email and we'll get back to use quick as we can. Thank you.\n                ")])])])])}]

export { render, staticRenderFns }